import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeatureFlag, HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface LoadFeatureFlagsResponse {
  flags: FeatureFlag[];
}

@Injectable({
  providedIn: 'root',
})
export class OccFeatureFlagService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  load(): Observable<FeatureFlag[]> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.featureFlag);

    return this.http
      .get<LoadFeatureFlagsResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.featureFlag),
      })
      .pipe(map((res) => res.flags));
  }
}
